import React, { useRef, useState } from "react";
import emailjs from "@emailjs/browser";

import { ContactSection } from "./styles";

import {
  Input,
  Textarea,
  Button,
  useToast,
  FormControl,
} from "@chakra-ui/react";

function FormContact() {
  const toast = useToast();
  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    if (name.length > 0 && email.length > 0 && message.length > 0) {
      emailjs
        .sendForm(
          "service_ar7sklp",
          "template_a7ypite",
          form.current,
          "lFUBbkpqZNB6mbpqi"
        )
        .then(
          (result) => {
            toast({
              title: `Mensagem enviada com sucesso!`,
              status: "success",
              isClosable: true,
              duration: 5000,
            });
          },
          (error) => {
            toast({
              title: `Ops, algo deu errado. Tente novamente`,
              status: "error",
              isClosable: true,
              duration: 5000,
            });
          }
        );
    }else{
      toast({
        title: `Favor preencher todos os campos`,
        status: "error",
        isClosable: true,
        duration: 5000,
      });
    }
  };

  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");

  return (
    <ContactSection name="contact">
      <h1>Contato</h1>
      <form ref={form} onSubmit={sendEmail}>
        <label>Nome</label>
        <Input
          onChange={(event) => setName(event.target.value)}
          placeholder="Seu nome"
          name="user_name"
        />
        <label>Email</label>
        <Input
          onChange={(event) => setEmail(event.target.value)}
          placeholder="Seu email"
          name="user_email"
        />
        <label>Mensagem</label>
        <Textarea
          onChange={(event) => setMessage(event.target.value)}
          placeholder="Escreva a sua mensagem"
          name="message"
        />
        <Button type="submit" value="Send" colorScheme="blue">
          Enviar
        </Button>
      </form>
    </ContactSection>
  );
}

export default FormContact;
